// extracted by mini-css-extract-plugin
export default {"answer":"M_-z","bestAnswerHeading":"N_-z","meta":"O_-z"};